import { Helmet } from 'react-helmet-async';

import { Content } from './components/Content';

export const AdminAttorneyUsersPage = () => {
  return (
    <>
      <Helmet>
        <title>Attorney Users - AutoScript Admin</title>
      </Helmet>

      <Content />
    </>
  );
};
